import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Modal, Segment } from "semantic-ui-react";
import { useGetRecipeById, useUpdateRecipe } from "../../../api/recipeSimulator";
import CommonModalCloseIcon from "../../../assets/commonIcon/CommonModalCloseIcon";
import { InputText, InputTextArea } from "../../../components";
import MainBottomMultipleButtonView from "../../../components/mainBottomButtonView/MainBottomMultipleButtonView";

interface UpdateRecipeModalProps {
  closeModal: () => void;
  recipeId: string;
}

const UpdateRecipeModal = ({ closeModal = () => {}, recipeId }: UpdateRecipeModalProps) => {
  const {
    data: recipeData,
    isFetching: isLoading,
    refetch: recipeDataRefetch
  } = useGetRecipeById(recipeId);
  const { mutate: updateRecipe, isLoading: isUpdating } = useUpdateRecipe();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    mode: "all",
    defaultValues: {
      recipeName: "",
      notes: ""
    }
  });

  useEffect(() => {
    if (recipeData) {
      reset({
        recipeName: recipeData.recipeName ?? "",
        notes: recipeData.notes ?? ""
      });
    }
  }, [recipeData, reset]);

  const onSubmit = async (data: any) => {
    if (!recipeData) return;

    updateRecipe(
      {
        recipeId,
        recipe: { recipeName: data.recipeName, notes: data.notes } 
      },
      {
        onSuccess: async () => {
          await recipeDataRefetch();
        },
        onSettled: () => {
          closeModal();
        }
      }
    );
  };

  return (
    <Modal
      centered={false}
      size={"small"}
      open={true}
      onClose={() => closeModal()}
      dimmer="blurring"
      className="custom-modal"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Content as={Segment} loading={isLoading || isUpdating}>
          <>
            <div className="modal-header">
              Update the Recipe Name & Notes
              <CommonModalCloseIcon onClick={closeModal} className="close-icon" />
            </div>
            <div className="modal-content">
              <InputText
                labelName={"Recipe Name*"}
                errorMessage="Recipe Name is required"
                name="recipeName"
                register={register}
                errors={errors.recipeName}
                required
              />
              <InputTextArea
                labelName={"Notes"}
                errorMessage="Notes are required"
                name="notes"
                register={register}
                errors={errors.notes}
              />
              <div style={{ marginBottom: "-1rem" }}></div>
              <MainBottomMultipleButtonView
                leftButtons={[
                  {
                    title: "Cancel",
                    onClick: () => closeModal(),
                    buttonOutLine: true
                  }
                ]}
                rightButtons={[
                  {
                    contentView: 16,
                    title: "Save",
                    onClick: () => {},
                    type: "submit",
                    buttonView: true
                  }
                ]}
              />
            </div>
          </>
        </Modal.Content>
      </form>
    </Modal>
  );
};

export default UpdateRecipeModal;
